import { gql } from 'graphql-tag'

export const bookNavigationFields = gql`
  fragment bookNavigationFields on Book {
    name
    author
    freemium
    slug
    language
    layout
    v2ready
    degree
    manualInfoChecked
    description
    imageUrlIntermediaria
    imageUrlThumb
    imageUrlThumbLow
    premium
    freemium
    premiumLock
    rights
    hasAudioBook
  }
`

export const getTeacherInfo = gql`
  query GetTeacherInfo {
    me {
      id
      secondEmail
      phone
      teacher {
        id
        disciplines {
          title
        }
        roles {
          title
        }
        yearsResponsibleFor
      }
    }
  }
`

export const favoriteBooksQuery = gql`
  query FavoriteBooksQuery {
    me {
      id
      reader {
        id
        favoriteBooks {
          ...bookNavigationFields
        }
      }
    }
  }
  ${bookNavigationFields}
`

export const listReadersWithSameDegreeQuery = gql`
  query OldListReadersSameDegree($term: String!) {
    me {
      id
      reader {
        id
        listReadersSameDegree(term: $term)
      }
    }
  }
`

export const entitiesSubtreeFlatQuery = gql`
  query EntitiesSubtreeFlatQuery {
    me {
      id
      teacher {
        id
        entitiesSubtreeFlat
      }
    }
  }
`
export const searchAvailableReadersToIndicateQuery = gql`
  query OldSearchAvailableReadersToIndicate($term: String!) {
    me {
      id
      teacher {
        id
        searchAvailableReadersToIndicate(term: $term)
      }
    }
  }
`

export const bookQuery = gql`
  ${bookNavigationFields}

  query BookBasicInfo($slug: String!) {
    bookDetails(slug: $slug) {
      ...bookNavigationFields
    }
  }
`

export const collectionQuery = gql`
  query collection($collectionId: Int!) {
    me {
      id
      reader {
        id
        collection(id: $collectionId) {
          id
          name
          image
          bgColor
          description
          books {
            author
            degree
            description
            edition
            imageUrlIntermediaria
            imageUrlThumb
            name
            readingLevel
            series
            slug
            subtitle
            hasAudioBook
          }
        }
      }
    }
  }
`

export const searchAllAvailableBooksQuery = gql`
  ${bookNavigationFields}

  query SearchAllAvailableBooks($searchTerm: String!, $page: Int) {
    searchAllAvailableBooks(searchTerm: $searchTerm, page: $page) {
      ...bookNavigationFields
    }
  }
`

export const searchBookForAutoCompleteQuery = gql`
  query OldSearchBookForAutoComplete($searchTerm: String!) {
    searchBook(searchTerm: $searchTerm) {
      name
      slug
    }
  }
`

export const searchBookForAutoCompleteActivityQuery = gql`
  query OldSearchBookForAutoCompleteActivity($searchTerm: String!) {
    searchBook(searchTerm: $searchTerm) {
      name
      slug
    }
  }
`

export const listMascots = gql`
  query listMascots {
    listMascots
  }
`

export const searchBnccAbilityForAutoCompleteQuery = gql`
  query SearchBnccAbilityForAutoComplete($term: String!) {
    searchBnccAbility(term: $term) {
      code
      description
    }
  }
`

export const searchBnccTagsForAutoCompleteQuery = gql`
  query SearchBnccTagsForAutoComplete($term: String!) {
    searchBnccTags(term: $term) {
      name
    }
  }
`

export const searchTextualGenresForAutoCompleteQuery = gql`
  query SearchTextualGenresForAutoComplete($term: String!) {
    searchTextualGenre(term: $term) {
      name
    }
  }
`

export const searchCategoryQueryWithFilter = gql`
  ${bookNavigationFields}

  query BooksInCategoryWithFilters(
    $searchTerm: String!
    $page: Int
    $opts: String
  ) {
    searchCategoryV2: searchCategoryV2(
      searchTerm: $searchTerm
      page: $page
      opts: $opts
    ) {
      searchFilters
      books {
        ...bookNavigationFields
      }
    }
  }
`

export const adminHomeInfos = gql`
  query adminHomeInfos {
    me {
      id
      firstAccess
      teacher {
        id
        countReaders
        totalTimeSpent
        entityContentConsumptionSummary {
          openedContentCount
          fullyConsumedContentCount
        }
        indicatedBooks
        preferredBooks
        mostReaders
        mostReadersByEntity
        root {
          id
          segment
        }
      }
    }
  }
`

export const preferredBooks = gql`
  query preferredBooks {
    me {
      id
      teacher {
        id
        preferredBooks
      }
    }
  }
`

export const getInitialDataForSharedBooksPageQuery = gql`
  query getInitialDataForSharedBooksPageQuery($page: Int!, $perPage: Int!) {
    me {
      id
      reader {
        id
        topGeneralSharedReadingsWeekly {
          book {
            name
            imageUrlThumb
            slug
            hasAudioBook
          }
          likedByMe
          likes
          lastUserShare
          sharedByMe
        }
        sharedReadingsBySchool: sharedReadings(
          page: $page
          perPage: $perPage
          sharedByMeOnly: false
        ) {
          book {
            name
            imageUrlThumb
            slug
            hasAudioBook
          }
          likedByMe
          likes
          lastUserShare
          shares
          sharedByMe
        }
      }
    }
  }
`

export const getMoreSharedBooksQuery = gql`
  query getMoreSharedBooksQuery(
    $page: Int!
    $perPage: Int!
    $sharedByMeOnly: Boolean!
  ) {
    me {
      id
      reader {
        id
        sharedReadings(
          page: $page
          perPage: $perPage
          sharedByMeOnly: $sharedByMeOnly
        ) {
          book {
            name
            imageUrlThumb
            slug
            hasAudioBook
          }
          likedByMe
          likes
          lastUserShare
          shares
          sharedByMe
        }
      }
    }
  }
`

export const allUserActivities = gql`
  query allUserActivities {
    me {
      id
      serverDateTime
      reader {
        id
        listAppliedActivities
      }
    }
  }
`

export const oldAllUserActivities = gql`
  query oldAllUserActivities {
    me {
      id
      reader {
        id
        surveys
      }
    }
  }
`

export const surveysOfMySchoolQuery = gql`
  query surveysOfMySchoolQuery {
    me {
      id
      teacher {
        id
        surveysOfMySchool
      }
    }
  }
`

export const allBookshelvesQuery = gql`
  query AllBookshelves(
    $isHighlight: Boolean!
    $acervoType: String
    $degreeRange: String
    $contentFilter: String
    $type: String
    $page: Int
    $perPage: Int
    $active: Boolean
  ) {
    listExistingBookshelf(
      degreeRange: $degreeRange
      isHighlight: $isHighlight
      acervoType: $acervoType
      contentFilter: $contentFilter
      type: $type
      page: $page
      perPage: $perPage
      active: $active
    ) {
      name
      active
      degreeRange
      id
      isHighlight
      type
      image
      bgColor
      description
      bookShelfItems {
        book {
          slug
          name
          imageUrlThumb
          author
          hasAudioBook
          degree
        }
        bookShelfId
        id
        mascot
      }
      bookShelfItemsCount
    }
  }
`

export const showBookShelfQuery = gql`
  query showBookShelfOld($bookShelfId: Int!, $limit: Int!) {
    showBookShelf(bookShelfId: $bookShelfId) {
      name
      subtitle
      degreeRange
      contentFilter
      isHighlight
      acervoType
      id
      type
      description
      image
      bgColor
      bookShelfItems(limit: $limit) {
        book {
          slug
          name
          imageUrlThumb
          author
          hasAudioBook
          degree
          premiumLock
        }
        bookShelfId
        id
        mascot
      }
      bookShelfItemsCount
    }
  }
`

export const getAcervoTypesQuery = gql`
  query getAcervoTypesQuery {
    getAcervoTypes
  }
`

// BNCC Didactic Sequence MUTATIONS
export const listDidacticSequencesQuery = gql`
  query listDidacticSequencesQuery {
    listDidacticSequences {
      id
      title
      isReady
      arvoreId
    }
  }
`

export const listSpecificSkills = gql`
  query ListSpecificSkills($knowledgeAreaId: Int!) {
    listSpecificSkills(knowledgeAreaId: $knowledgeAreaId) {
      description
      id
    }
  }
`

export const listGeneralSkills = gql`
  query ListGeneralSkills {
    listGeneralSkills {
      id
      description
    }
  }
`

export const getDidacticSequenceQuery = gql`
  query GetDidacticSequence($didacticSequenceId: Int!) {
    getDidacticSequence(didacticSequenceId: $didacticSequenceId) {
      isFavorite
      arvoreId
      author
      contents
      evaluation
      id
      isReady
      purposes
      summary
      title
      tags {
        id
        name
      }
      activity {
        id
        description
        didacticSequenceId
        examQuestions {
          id
          baseText {
            id
            statement
          }
          bnccAbility {
            bnccAbility {
              id
              code
              description
            }
          }
          books {
            name
            slug
            imageUrlThumb
            author
          }
          commentedAnswer
          examQuestionChoices {
            examQuestionId
            id
            isCorrect
            statement
            tempImage
          }
          statement
          type
        }
        isBncc
        title
      }
      bnccAbilities {
        id
        code
        degreeRange
        description
        practiceObjectId
        practiceObject {
          name
          fieldPractice {
            name
          }
        }
      }
      bnccDegrees {
        degree
        id
      }
      books {
        name
        slug
        author
        imageUrlThumb
      }
      lessons {
        text
        id
      }
      specificSkills {
        description
        id
        knowledgeAreaId
      }
      tags {
        name
        id
      }
      textualGenres {
        name
        id
      }
    }
  }
`

export const searchDidacticSequenceQuery = gql`
  query SearchDidacticSequence(
    $searchTerm: String!
    $opts: String
    $page: Int
  ) {
    searchDidacticSequence(searchTerm: $searchTerm, opts: $opts, page: $page) {
      searchFilters
      didacticSequences {
        title
        id
        actionFields {
          id
          name
        }
        lessons {
          text
        }
        textualGenres {
          name
        }
        degrees {
          degree
        }
      }
    }
  }
`

export const listFullDidacticSequencesQuery = gql`
  query ListDidacticSequences($favorite: Boolean, $isReady: Boolean = true) {
    listDidacticSequences(favorite: $favorite, isReady: $isReady) {
      title
      id
      bnccAbilities {
        code
        practiceObject {
          id
          name
          fieldPractice {
            id
            name
            actionField {
              id
              name
            }
          }
        }
      }
      lessons {
        text
      }
      textualGenres {
        name
      }
      bnccDegrees {
        degree
      }
    }
  }
`

export const listBnccAbilitiesForFilterQuery = gql`
  query ListBnccAbilitiesForFilter {
    listBnccAbilitiesForFilter {
      id
      code
      description
    }
  }
`

// END BNCC Didactic Sequence Queries

export const getActivityQuery = gql`
  query OldGetActivity($activityId: Int!) {
    getActivity(activityId: $activityId) {
      id
      title
      moduleId
      description
      submittedToPublic
      isReady
      degreeRange
      authorInfo {
        facebookPhoto
        name
        school
      }
      books {
        slug
        author
        name
        imageUrlThumb
        publisher {
          id
          name
        }
      }
      articles {
        id
        image
        title
        author
        degree
        publishDate
        subtitle
      }
      publicDataActivity {
        generalSkills {
          id
          description
        }
        degreeRange
        email
        id
        objective
        publicActivityId
        school
        sourceActivityId
        tags {
          name
        }
        textualGenres {
          id
          name
        }
      }
      examQuestions {
        statement
        type
        id
        tempImage
        examQuestionMatchingPairs {
          id
          leftId
          leftStatement
          rightId
          rightStatement
        }
        examQuestionChoices {
          id
          statement
          isCorrect
          tempImage
        }
      }
    }
  }
`

export const getPublicActivityQuery = gql`
  query GetPublicActivity($activityId: Int!) {
    getPublicActivity(activityId: $activityId) {
      id
      title
      description
      submittedToPublic
      isReady
      difficultyLevel
      estimatedCompletionTimeInSeconds
      authorInfo {
        facebookPhoto
        name
        school
      }
      books {
        slug
        author
        name
        imageUrlThumb
      }
      publicDataActivity {
        generalSkills {
          id
          description
        }
        degreeRange
        email
        id
        objective
        publicActivityId
        school
        sourceActivityId
        tags {
          name
        }
        textualGenres {
          id
          name
        }
      }
      examQuestions {
        statement
        type
        id
        examQuestionChoices {
          id
          statement
          isCorrect
          tempImage
        }
        bnccAbilities {
          id
          code
          description
          practiceObject {
            id
            name
            fieldPractice {
              id
              name
              actionField {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`

export const curationGetActivityQuery = gql`
  query CurationGetActivity($activityId: Int!) {
    me {
      id
      teacher {
        id
        curationGetActivity(activityId: $activityId) {
          id
          title
          description
          submittedToPublic
          isReady
          authorInfo {
            facebookPhoto
            name
            school
          }
          books {
            slug
            author
            name
            imageUrlThumb
            publisher {
              id
              name
            }
          }
          publicDataActivity {
            generalSkills {
              id
              description
            }
            degreeRange
            email
            id
            objective
            publicActivityId
            school
            sourceActivityId
            tags {
              id
              name
            }
            textualGenres {
              id
              name
            }
          }
          examQuestions {
            statement
            type
            id
            examQuestionChoices {
              id
              statement
              isCorrect
              tempImage
            }
          }
        }
      }
    }
  }
`

export const listMyActivitiesQuery = gql`
  query listMyActivitiesQuery {
    me {
      id
      teacher {
        id
        listMyActivities {
          id
          title
          books {
            slug
            author
            name
            imageUrlThumb
            publisher {
              id
              name
            }
          }
        }
      }
    }
  }
`

export const listApplicationsForActivityQuery = gql`
  query listApplicationsForActivityQuery($activityId: Int!) {
    me {
      id
      teacher {
        id
        listApplicationsForActivity(activityId: $activityId) {
          startDate
          endDate
          readerId
          entityId
          id
          createdAt
          title
        }
      }
    }
  }
`

export const searchReadersQuery = gql`
  query SearchReaders($searchTerm: String!) {
    me {
      id
      teacher {
        id
        searchReaders(searchTerm: $searchTerm)
      }
    }
  }
`

export const categoriesQuery = gql`
  query CategoriesPage {
    me {
      id
      reader {
        id
        entity {
          id
          customCategories {
            name
            iconPath
          }
        }
      }
    }
  }
`
export const getTemporarilyBooksQuery = gql`
  query getTemporarilyBooksQuery {
    me {
      id
      reader {
        id
        entity {
          id
          temporarilyBooks
        }
      }
    }
  }
`

export const getNpsScore = gql`
  query getNpsScore {
    me {
      id
      npsScore {
        score
        source
        createdAt
      }
    }
  }
`

export const trialFirstAccessQuery = gql`
  query trialFirstAccessQuery {
    me {
      id
      teacher {
        id
      }
    }
  }
`

export const getDataHomeForest = gql`
  query DataHomeForestOld($count: Int) {
    me {
      id
      reader {
        id
        forest {
          id
          coins
          treeListings(count: $count) {
            id
            image
          }
        }
      }
    }
  }
`

export const getDataMainForestScreen = gql`
  query GetDataMainForestScreen {
    me {
      id
      reader {
        id
        forest {
          id
          coins
          trees {
            id
            specialItemUsed
            stage
            agePercentage
            description
            growthTime
            image
            name
            position
            scientificName
            species
            ageStatusText
          }
          seeds {
            id
            image
            name
            description
            locked
            lockedText
            scientificName
            species
            growthTime
            price
          }
          specialItems {
            id
            name
            description
            price
            action
            image
            type
          }
          waterDropDetails {
            raining
          }
        }
      }
    }
  }
`

export const getForestFriendsData = gql`
  query friendTreeListings($friendReaderId: Int!) {
    me {
      id
      reader {
        id
        forest {
          id
          friendTreeListings(friendReaderId: $friendReaderId) {
            id
            image
            position
          }
        }
      }
    }
  }
`

export const getFriendsForUserData = gql`
  query friends($page: Int!, $count: Int!) {
    me {
      id
      reader {
        id
        forest {
          id
          friends(page: $page, count: $count) {
            name
            readerId
          }
        }
      }
    }
  }
`

export const getFriendsForAdminData = gql`
  query friendsForAdmin($entityId: Int!, $page: Int!, $count: Int!) {
    me {
      id
      reader {
        id
        forest {
          id
          friendsForAdmin(entityId: $entityId, page: $page, count: $count) {
            id
            name
            type
          }
        }
      }
    }
  }
`

export const getMyForestAndSeedsData = gql`
  query GetMyForestAndSeedsData {
    me {
      id
      reader {
        id
        forest {
          id
          coins
          trees(count: 20) {
            id
            specialItemUsed
            stage
            agePercentage
            description
            growthTime
            image
            name
            position
            scientificName
            species
            ageStatusText
          }
          seeds {
            id
            image
            name
            description
            locked
            lockedText
            scientificName
            species
            growthTime
            price
          }
        }
      }
    }
  }
`

export const getStoreData = gql`
  query GetStoreData {
    me {
      id
      reader {
        id
        forest {
          id
          coins
          seeds {
            id
            image
            name
            description
            locked
            lockedText
            scientificName
            species
            growthTime
            price
          }
          waterDropDetails {
            raining
          }
        }
      }
    }
  }
`

// Client Management
export const getClientListingQuery = gql`
  query GetClientListing($filters: ClientListingFilters) {
    getClientListing(filters: $filters) {
      id
      name
      deactivated
    }
  }
`

export const searchLoginTypeQuery = gql`
  query SearchLoginType(
    $prefixOrSufix: LoginTypePrefixOrSufix!
    $profileType: ProfileType!
    $term: String!
  ) {
    searchLoginType(
      prefixOrSufix: $prefixOrSufix
      profileType: $profileType
      term: $term
    ) {
      id
    }
  }
`

export const getClientQuery = gql`
  query GetClient($clientId: Int!) {
    me {
      id
    }
    getClient(clientId: $clientId) {
      id
      name
      accessCode
      isTrial
      whoPays
      loginType
      payingClient
      responsibleName
      responsibleEmail
      schoolStructure
      segment
      internalContacts
      usesContractModuleSystem
      entityType
      blockAccessTokens
      deactivated
      maxSimultaneousUsers
      clientContracts {
        id
        type
        contractModules {
          id
          contractId

          info {
            ... on CnpjPayingModuleInfoPayload {
              minUsers
              freeUsers
              pricePerUnit
              bookCollection
            }
            ... on FamilyPayingModuleInfoPayload {
              minUsers
              pricePerUnit
              discount
              discountExpirationDate
              bookCollection
            }
            ... on PublicModuleInfoPayload {
              numberOfReaders
              bookCollection
            }
            ... on ProjectModuleInfoPayload {
              maxTeachers
              maxReaders
              bookCollection
            }
            ... on TrialModuleInfoPayload {
              maxTeachers
              maxReaders
              bookCollection
            }
          }

          module {
            name
          }
        }
      }
      contractModules {
        id
        contractId

        module {
          name
        }
      }
    }
    getContractListing(clientId: $clientId) {
      active
      clientId
      clientName
      contractType
      contractId
      contractModules {
        id
        contractId

        module {
          name
        }
      }
      active
    }
    getSubtreeFromEntityListing(entityId: $clientId) {
      child
      parentId
      parentName
      accessCode
      degree
      entityId
      entityName
      entityAncestry
      entityType
      contractModules {
        id
        contractId

        module {
          name
        }
      }
    }
  }
`

export const getContractListingQuery = gql`
  query GetContractListingQuery {
    getContractListing {
      active
      clientId
      clientName
      contractType
      contractId
      contractModules {
        id
        contractId

        module {
          name
        }
      }
      active
    }
  }
`

export const getSubtreeFromEntityListingQuery = gql`
  query GetSubtreeFromEntityListingQuery($entityId: Int!) {
    getSubtreeFromEntityListing(entityId: $entityId) {
      degree
      child
      parentId
      parentName
      entityId
      entityName
      entityAncestry
      entityType
      contractModules {
        contractId

        module {
          id
          name
        }
      }
    }
  }
`

export const getReadersAccessInfoQuery = gql`
  query GetReadersAccessInfoQuery(
    $entityId: Int!
    $source: ReadersInfoSourceType!
    $profileType: ProfileType!
  ) {
    readersAccessInfo(
      entityId: $entityId
      source: $source
      profileType: $profileType
    ) {
      ... on ReadersAccessInfoPayload {
        entityName
        accessCode
        readerName
        accessToken
        url
      }
      ... on Card {
        id
        name
        entityName
        accessToken
      }
    }
  }
`

export const getContractDataQuery = gql`
  query GetContractDataQuery($contractId: Int!) {
    getAcervoTypes
    listCollections {
      id
      name
    }
    listBookCollections {
      id
      name
    }
    getContract(contractId: $contractId) {
      active
      cnpj
      clientId
      clientName
      companyName
      contractModules {
        collections {
          id
          name
        }
        bookCollections {
          id
          name
        }
        extraInformation {
          ... on CnpjPayingExtraInformation {
            activeUsers
            chargedUsers
            totalAmount
          }
          ... on FamilyPayingExtraInformation {
            activeUsers
            paidUsers
          }
          ... on PublicExtraInformation {
            activeUsers
            numberOfReaders
          }
          ... on ProjectExtraInformation {
            maxReaders
            maxTeachers
          }
          ... on TrialExtraInformation {
            maxReaders
            maxTeachers
          }
        }

        info {
          ... on CnpjPayingModuleInfoPayload {
            minUsers
            freeUsers
            pricePerUnit
            bookCollection
          }
          ... on FamilyPayingModuleInfoPayload {
            minUsers
            pricePerUnit
            discount
            discountExpirationDate
            bookCollection
          }
          ... on PublicModuleInfoPayload {
            numberOfReaders
            bookCollection
          }
          ... on ProjectModuleInfoPayload {
            maxTeachers
            maxReaders
            bookCollection
          }
          ... on TrialModuleInfoPayload {
            maxTeachers
            maxReaders
            bookCollection
          }
        }

        module {
          name
        }
      }
      billingAddress {
        address
        city
        complement
        country
        neighborhood
        number
        state
        zipcode
      }
      contractId
      contractType
      disableContractAfterExpiration
      endDate
      entityName
      expirationWarningDays
      financeContactEmail
      financeContactName
      financeContactPhone
      observation
      paymentInfo
      signatureDate
      startDate
      stateRegistration
      municipalRegistration
      market
      tradingName
      firstChargeDate
    }
  }
`

export const getImportationListingQuery = gql`
  query GetImportationListingQuery($userId: Int!, $clientId: Int) {
    importationListing(userId: $userId, clientId: $clientId) {
      clientName
      id
      processType
      progress
      status
      userName
    }
  }
`

export const getImportationReview = gql`
  query ImportationReview($id: Int!) {
    importReview(id: $id)
  }
`

export const getImportationInfo = gql`
  query Importation($id: Int!) {
    getImportation(id: $id) {
      id
      clientName
      clientId
      userName
      status
    }
  }
`

export const entityPublicInfo = gql`
  query entityPublicInfo($code: String!) {
    entityPublicInfo(code: $code) {
      rootName
      degree
    }
  }
`

export const getBooksDeactivationDates = gql`
  query getBooksDeactivationDates($slugs: [String]!) {
    bookRemovalDates(slugs: $slugs) {
      slug
      deactivationDate
    }
  }
`

export const getRootPublicInfo = gql`
  query getRootPublicInfo($code: String!) {
    rootPublicInfo(code: $code) {
      id
      name
    }
  }
`

export const getLayersPaymentEntityInfoQuery = gql`
  query LayersPaymentEntityInfo($externalTransactionId: String!) {
    layersPaymentEntityInfo(externalTransactionId: $externalTransactionId) {
      arvoreEntityId
      entityName
    }
  }
`

export const getUserPublicInfo = gql`
  query getUserPublicInfo($input: UserPublicInfoInput!) {
    userPublicInfo(input: $input) {
      id
      name
      paid
    }
  }
`

export const getMaximumHierarchyType = gql`
  query GetMaximumHierarchyType($rootId: Int!) {
    maximumHierarchyType(rootId: $rootId) {
      hierarchyType
    }
  }
`

export const getSchoolsByRoot = gql`
  query GetSchoolsByRoot($rootId: Int!, $type: String!) {
    schoolsByRoot(rootId: $rootId, type: $type) {
      id
      name
    }
  }
`

export const findReaders = gql`
  query FindReaders($entityId: Int!, $term: String!) {
    findReaders(entityId: $entityId, term: $term) {
      id
      name
    }
  }
`

export const getAcquisitonPlan = gql`
  query acquisitionPlansOld {
    acquisitionPlans {
      iconUri
      id
      name
      price
      productSum
      products {
        id
        name
        price
      }
      type
    }
  }
`

export const getForestDropsData = gql`
  query getForestDropsData {
    me {
      id
      reader {
        id
        forest {
          id
          waterDropDetails {
            currentDrops
            dropsPerLevel
            maxDrops
            minimumLevel
            raining
          }
        }
      }
    }
  }
`

export const getUsersListingQuery = gql`
  query GetUsersListing($page: Int, $perPage: Int, $search: String) {
    getUsersListing(page: $page, perPage: $perPage, search: $search) {
      id
      name
      email
      entity {
        id
        name
      }
      root {
        id
        name
      }
    }
    totalUsers
  }
`
